module.exports = __webpack_public_path__ + "static/media/29DUNON2.8096609f.jpg";